export default __webpack_public_path__ + "static/media/plan_empty.2937632b.png";